import { render, staticRenderFns } from "./rankmatch_errorexercise_list.vue?vue&type=template&id=5bb18ccb&scoped=true"
import script from "./rankmatch_errorexercise_list.vue?vue&type=script&lang=js"
export * from "./rankmatch_errorexercise_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb18ccb",
  null
  
)

export default component.exports